import { Component, OnInit } from '@angular/core';
import { NgFor, NgIf, NgClass } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { LeagueWeek } from '../../models/LeagueWeek';
import { GolfEventService } from '../../services/golf-event.service';
import { GolfEvent } from '../../models/GolfEvent';
import { WeeklyRoundListComponent } from './weekly-round-list/weekly-round-list.component';
import { PERMISSIONS } from '../../models/constants';
import { AuthenticationService } from '../../services/authentication.service';
import { CreateWeekComponent } from './create-week/create-week.component';
import { FieldComponent } from './field/field.component';
import { ApplicationService } from '../../services/application.service';

@Component({
  selector: 'app-league',
  standalone: true,
  imports: [NgFor, NgIf, NgClass, WeeklyRoundListComponent, CreateWeekComponent, FieldComponent],
  templateUrl: './league.component.html',
  styleUrl: './league.component.css'
})
export class LeagueComponent implements OnInit {
  constructor(private route: ActivatedRoute, private golfEventService:GolfEventService, private authenticationService:AuthenticationService, private applicationService:ApplicationService){}

  league:GolfEvent|null = null;
  eventId:number|null = null;
  leagueWeeks:Array<LeagueWeek> = [];
  selectedWeek:LeagueWeek|null = null;
  containerDisplay="WEEKLIST";
  canAddWeek:boolean = false;
  paymentLink:string = '';

  ngOnInit(): void {
    this.eventId = Number(this.route.snapshot.paramMap.get('id'));
    this.setupPermissions();
    this.getLeague(this.eventId);
    this.getLeagueWeeks(this.eventId);
  }

  async setupPermissions():Promise<void> {
      this.canAddWeek = await this.authenticationService.hasPermission(PERMISSIONS.EVENTADMIN);
  }

  async getLeague(eventId:number) {
    this.league = await this.golfEventService.getGolfEventById(eventId);
    this.paymentLink = this.golfEventService.generatePaymentLink(this.league);
  }

  async getLeagueWeeks(eventId:number) {
    this.applicationService.showGlobalSpinner();
    this.leagueWeeks = await this.golfEventService.getLeagueWeeks(eventId);
    this.applicationService.hideGlobalSpinner();
  }

  selectWeek(week:LeagueWeek) {
    this.selectedWeek = week;
    this.containerDisplay = 'WEEKINFO';
  }

  refreshWeeks():void {
    if(!this.eventId) return;
    this.getLeagueWeeks(this.eventId);
    this.containerDisplay = 'WEEKLIST'
  }
}
